export default {
    methods: {
/*         end(query) {
            query = Object.assign(query, this.$route.query)
            let baseUrl = window.location.toString().split('?')[0]
            let queryString = Object.entries(query).map(entry => entry.join('=')).join('&')
            window.location = [baseUrl, queryString].join('?')
        }, */

        result(result, additionQuery) {
            this.$router.replace({ name: 'wv-away', params: { result: result, query: additionQuery || {} }})
        },

        regOk(query) {
            return this.result('registration-ok', query)
        },

        phoneOk() {
            return this.result('phone-ok')
        },

        wiredOk(query) {
            return this.result('wired-ok', query)
        },

        cancel() {
            return this.result('cancel')
        },

        error(errorMessage) {
           return this.result('cancel', { error: errorMessage })
        },

        refresh() {
            
        }
    }
}